import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Edit } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const d = new Date();

export default class EditHoliday extends Component {
  constructor(props) {
    super();
    this.state = {
      showEditModal: false,
      updated_by: cookies.get("email"),
      hasError: false,
      disableSubmit: false,
    };
    this.handleshowEditModal = this.handleshowEditModal.bind(this);
  }

  handleshowEditModal = (e) => {
    this.setState({ showEditModal: !this.state.showEditModal, hasError: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableSubmit: true });
    axios
      .put("api/holiday/" + this.props.holidayDetail.id, this.state)
      .then((res) => {
        this.props.parentCallback(true);
        this.setState({ showEditModal: false, disableSubmit: false });
      })
      .catch((err) => {
        this.setState({ disableSubmit: false, hasError: true });
      });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-success btn-sm"
          title="Edit Holiday"
          onClick={this.handleshowEditModal}
        >
          <Edit />
        </button>
        <Modal
          size="md"
          backdrop="static"
          show={this.state.showEditModal}
          onHide={() =>
            this.setState({ showEditModal: !this.state.showEditModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Edit Holiday</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  Holiday Date already existing.
                </div>
              </div>
            </div>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Status</label>
                  <select
                    class="form-control custom-select"
                    onChange={(e) =>
                      this.setState({ holiday_type: e.target.value })
                    }
                  >
                    <option
                      value={1}
                      selected={
                        this.props.holidayDetail.holiday_type == 1
                          ? "selected"
                          : ""
                      }
                    >
                      REGULAR
                    </option>
                    <option
                      value={2}
                      selected={
                        this.props.holidayDetail.holiday_type == 2
                          ? "selected"
                          : ""
                      }
                    >
                      SPECIAL
                    </option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    onChange={(e) => this.setState({ name: e.target.value })}
                    defaultValue={this.props.holidayDetail.name}
                  />
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Date</label>
                  <input
                    type="date"
                    min={d.getFullYear()+"-01-01"}
                    className="form-control"
                    required
                    onChange={(e) =>
                      this.setState({ holiday_date: e.target.value })
                    }
                    defaultValue={this.props.holidayDetail.holiday_date}
                  />
                </div>
              </div>

              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableSubmit}
                >
                  Save
                </button>
                <button
                  onClick={this.handleshowEditModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
